<template>
  <div v-if="isLoadingIndustry" class="forestry">
    <section class="hero">
      <div class="hero__cover" v-if="industry.coverimage" :style="{ backgroundImage: `url('${ $filters.imageUrl(industry.coverimage.url) }')` }"></div>
      <div class="hero__content">
        <div class="hero__content__wrap">
          <h1 class="text-white font-bold">{{ industry.title | i18n }}</h1>
          <p class="whitespace-pre-wrap">{{ industry.intro | i18n}}</p>
          <span class="hero__btn btn-cta" @click="openContactForm"><div class="btn btn-solid btn-blue gradient-btn"><span>{{ $t('contactAndBuy') }}</span><i class="owl-direction-right"></i></div></span>
        </div>
      </div>
    </section>
    <section class="container py-48">
      <div class="text-left sm:text-center">
        <h2 class="mb-16 text-4xl font-bold">{{ $t('custom.forestry.title') }}</h2>
        <h3 class="font-bold text-2xl">{{ $t('custom.forestry.subTitle') }}</h3>
        <p class="text-lg max-w-lg mx-auto text-white leading-xl text-left my-32 font-bold whitespace-pre-line">{{ $t('custom.forestry.content') }}</p>
        <a v-if="industry.campaign_link" :href="industry.campaign_link" target="_blank"><div class="btn btn-lg btn-solid btn-blue capitalize gradient-btn pr-12">{{ industry.campaign_button_name | i18n }}<i class="owl-direction-right pl-8"></i></div></a>
      </div>
    </section>
    <section>
      <img class="mx-auto block max-w-full" src="@/assets/forestry-bg.png">
    </section>
    <section class="container py-48">
      <div class="mb-64">
        <h2>{{ $t('blockChainBenefits') }}</h2>
        <div class="categories__wrap">
          <div v-for="(feature, index) in industry.features" :key="index" class="categories__item__wrap flex">
            <div class="categories__item">
              <img v-if="feature.logo && feature.logo.url" :src="$filters.imageUrl(feature.logo.url)">
              <h4 class="capitalize">{{ feature.name | i18n }}</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container py-48">
      <h2 v-t="'custom.forestry.blockTitle.product'">產品發表記者會</h2>
      <div class="productLaunch flex flex-wrap">
        <component
          :is="itemUrl(item) ? 'a' : 'div'"
          v-for="(item, index) in productLaunch"
          :href="itemUrl(item) || null"
          :target="itemUrl(item) ? '_blank' : null"
          class="productLaunch__wrap"
          :class="index === 0 ? 'w-full md:w-2/3' : 'w-1/2 md:w-1/3'"
          :key="item.id">
          <div class="productLaunch__content" :style="{ backgroundImage: `url('${ item.cover ? $filters.imageUrl(item.cover.url) : '' }')` }">
            <div class="productLaunch__title">{{ item.title | i18n }}</div>
          </div>
        </component>
      </div>
    </section>
    <section class="container py-48">
      <h2 v-t="'custom.forestry.blockTitle.news'">媒體報導</h2>
      <div class="newsAlbum flex flex-wrap">
        <component
          :is="itemUrl(item) ? 'a' : 'div'"
          v-for="item in newsAlbum"
          :href="itemUrl(item) || null"
          :target="itemUrl(item) ? '_blank' : null"
          class="newsAlbum__wrap w-full md:w-1/2 lg:w-1/4"
          :key="item.name"
        >
          <div class="newsAlbum__content" :style="{ backgroundImage: `url('${ item.cover ? $filters.imageUrl(item.cover.url) : '' }')` }">
            <div class="newsAlbum__bottom">
              <div class="newsAlbum__logo">
                <img :src="item.logo ? $filters.imageUrl(item.logo.url) : ''">
              </div>
              <div class="newsAlbum__intro">{{ item.description | i18n }}</div>
            </div>
          </div>
        </component>
      </div>
    </section>
    <section v-if="industry.youtubeID || industry.video" class="container pt-32 pb-64">
      <div>
        <h2>{{ $t('spotlight') }}</h2>
        <div class="videoWrapper mt-16 mb-64">
          <iframe :src="`https://www.youtube.com/embed/${$filters.i18n(industry['YoutubeID-i18n'])}?modestbranding=1`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </section>
    <section class="belt bg-grey-lightest" :class="{'bg-white': !isCampaign}">
      <div class="container">
        <div class="belt__left flex flex-col justify-between">
          <div>
            <h2 style="color: #191e38;" class="font-bold" v-t="'banner.title'">成為OBS的合作夥伴</h2>
            <p v-t="'banner.description'">立即註冊將有專人與您聯繫，為您打造客製化OBS服務</p>
          </div>
            <span class="inline-block mb-48 btn-cta" @click="openContactForm"><div class="btn btn-solid btn-blue belt-btn-rwd gradient-btn" style="width: 350px; max-width: 80%;"><span>{{ $t('contactAndBuy') }}</span><i class="owl-direction-right"></i></div></span>
        </div>
        <div class="belt__right">
          <img class="p-32" src="@/assets/contact.png" alt="contact">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'routerNames',
      'industry',
      'solutions',
      'news'
    ]),
    productLaunch () {
      return this.$store.getters.news('productLaunch')
    },
    newsAlbum () {
      return this.$store.getters.news('newsAlbum')
    },
    isLoadingIndustry: function () {
      return !_.isEmpty(this.industry)
    },
    isCampaign: function () {
      return !_.isEmpty(this.industry.campaign_title) || !_.isEmpty(this.industry.campaign_description)
    }
  },
  methods: {
    ...mapActions([
      'openContactForm',
      'fetchNews'
    ]),
    itemUrl (item) {
      return this.$filters.i18n(item.url)
    }
  },
  created () {
    this.fetchNews()
  }
}
</script>

<style lang="sass" scoped>
.forestry
  background-color: #191e38
  h1, h2, h3
    @apply text-white

.hero
  &__btn
    .btn
      @apply w-full
      @screen sm
        @apply w-auto
  &__cover
    @apply flex-auto
  &__content
    @apply w-full
    @screen md
      @apply w-2/5
.categories
  &__wrap
    @apply flex flex-wrap
  &__item__wrap
    @apply w-1/2 p-8
    @screen md
      @apply w-1/3
    @screen lg
      @apply w-1/4
  &__item
    @apply shadow bg-transparent p-16 rounded
    img
      @apply mb-16
    h4
      @apply text-center text-white
.productLaunch
  &__wrap
    @apply p-8
  &__content
    background:
      color: #191e28
      size: cover
    height: 300px
    position: relative
    @apply bg-center
    // @apply ease
    // -webkit-filter: brightness(.85)
    // &:hover
    //   -webkit-filter: brightness(1)
  &__title
    @apply text-white w-full px-16 py-8
    background-color: rgba(#000, 0.7)
    position: absolute
    bottom: 0
.newsAlbum
  &__wrap
    @apply py-8
  &__content
    background:
      color: #191e28
      size: cover
    height: 340px
    position: relative
    @apply ease
    -webkit-filter: brightness(.85)
    &:hover
      -webkit-filter: brightness(1)
  &__bottom
    @apply w-full px-16 py-8
    background-color: rgba(#000, 0.6)
    position: absolute
    bottom: 0
  &__logo
    @apply my-8
    img
      @apply block
  &__intro
    @apply text-white leading-md

</style>
